export const trim = (value?: string | null): string | undefined => {
  if (value === undefined || value === null) return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const normalizeNameKey = (value?: string | null): string | null => {
  const trimmed = trim(value);
  return trimmed ? trimmed.toLocaleLowerCase('it-IT') : null;
};

export const toNonNegativeInt = (
  value: number | string | null | undefined,
  fallback = 0
): number => {
  if (value === undefined || value === null) return fallback;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return fallback;
  return Math.max(0, Math.round(numeric));
};

export const toNonNegativeNumber = (
  value: number | string | null | undefined
): number | undefined => {
  if (value === undefined || value === null || value === '') return undefined;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return undefined;
  return Math.max(0, numeric);
};
